import parentScope from '../types';

export const SCOPE = `${parentScope}.comparison`;
export const SET_COMPARISON_INTERVAL = `${SCOPE}/SET_COMPARISON_INTERVAL`;
export const COMPARISON_UNAVAILABLE = `${SCOPE}/COMPARISON_UNAVAILABLE`;
